import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SubscriptIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Subscript",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "m20.22 25.51-6.68-10.59 6.06-9.57c.18-.28.29-.63.29-1 0-.66-.34-1.23-.85-1.57-.28-.19-.63-.3-1-.3-.66 0-1.24.34-1.57.86s-5.09 8.08-5.09 8.08L6.25 3.36c-.34-.52-.91-.87-1.57-.87-.37 0-.71.11-1 .29-.52.33-.87.91-.87 1.57 0 .37.11.71.29 1s6.04 9.55 6.04 9.55L2.29 25.69c-.18.28-.29.63-.29 1 0 .66.34 1.23.85 1.57.28.19.63.3 1 .3.66 0 1.24-.34 1.57-.86l5.9-9.32 5.74 9.09c.33.57.93.95 1.62.95a1.856 1.856 0 0 0 1.52-2.93s0 .01 0 .01Zm8.85 4h-3.73c-.51 0-.93-.42-.93-.93v-3.73c0-.51.42-.93.93-.93h2.79v-1.86h-2.79c-.51 0-.93-.42-.93-.93s.42-.93.93-.93h3.73c.51 0 .93.42.93.93v3.73c0 .51-.42.93-.93.93h-2.79v1.86h2.79c.51 0 .93.42.93.93s-.42.93-.93.93"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M16.26 28.29c-.39 0-.78-.21-.99-.57L8.01 15.15c-.2-.35-.2-.79 0-1.14l7.26-12.58c.32-.55 1.02-.73 1.56-.42.55.32.73 1.01.42 1.56l-6.93 12 6.93 12c.32.55.13 1.25-.42 1.56-.18.1-.38.15-.57.15Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M1 28.29c-.19 0-.39-.05-.57-.15-.55-.32-.73-1.01-.42-1.56l6.93-12L0 2.57c-.32-.55-.13-1.25.42-1.56s1.25-.13 1.56.42L9.24 14c.2.35.2.79 0 1.14L1.99 27.71c-.21.37-.6.57-.99.57ZM25.09 22.74c1.63-1.33 4.24-2.71 4.24-4.73 0-1.55-1.19-2.71-3.38-2.71-1.66 0-3.17.86-4.77 2.34h-.05V15c1.46-1.16 3.26-1.92 5.21-1.92 3.09 0 5.33 2.09 5.33 4.8 0 2.95-2.75 4.65-4.67 6.18-1.8 1.43-3.31 2.46-3.56 4.28h8.42v2.22h-11.2c-.41-4.01 1.95-5.79 4.43-7.83Z"
      })]
    })
  }));
};
SubscriptIcon.displayName = 'SubscriptIcon';